import { VStack, Button } from '@chakra-ui/react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { Input, SelectInput } from '@/components/atoms/Input';
import { CircuitIdOption } from '../services/faturaApi';

const schema = z.object({
  circuit_id_integration: z.string().min(1, 'Selecione um Circuit ID'),
  wifi_ssid: z.string().min(1, 'Informe o SSID do WiFi'),
  wifi_password: z.string().min(1, 'Informe a senha do WiFi'),
});

type FormData = z.infer<typeof schema>;

interface RouterCredentialsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: FormData) => Promise<void>;
  circuitIds: CircuitIdOption[];
  isLoadingCircuitIds: boolean;
  isSubmitting: boolean;
  colors: { primaryColor: string };
}

export function RouterCredentialsModal({
  isOpen,
  onClose,
  onSubmit,
  circuitIds,
  isLoadingCircuitIds,
  isSubmitting,
  colors,
}: RouterCredentialsModalProps) {
  const form = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      circuit_id_integration: '',
      wifi_ssid: '',
      wifi_password: '',
    },
  });

  const handleSubmit = async (data: FormData) => {
    await onSubmit(data);
    form.reset();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Troca de Credenciais do Roteador</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <ModalBody>
            <VStack spacing={4}>
              <SelectInput
                control={form.control}
                name="circuit_id_integration"
                label="Circuit ID"
                placeholder={isLoadingCircuitIds ? 'Carregando...' : 'Selecione um Circuit ID'}
                options={circuitIds}
                disabled={isLoadingCircuitIds}
              />
              <Input
                control={form.control}
                name="wifi_ssid"
                label="SSID do WiFi"
                autoComplete="new-password"
                placeholder="Digite o nome da rede WiFi"
              />
              <Input
                control={form.control}
                name="wifi_password"
                label="Senha do WiFi"
                autoComplete="new-password"
                placeholder="Digite a senha do WiFi"
              />
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              variant="ghost"
              backgroundColor="transparent"
              color={colors.primaryColor}
              onClick={onClose}
              marginRight={2}
            >
              Cancelar
            </Button>
            <Button type="submit" isLoading={isSubmitting} isDisabled={isLoadingCircuitIds}>
              Salvar
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
